import cookie from 'react-cookies';
export var COOKIE_TYPES = {
    JWT: 'jwt'
};
var COOKIE_EXPIRES = 365; // year expiration duration
/**
 *
 */
var Cookies = /** @class */ (function () {
    function Cookies() {
    }
    /**
     *
     * @param type
     */
    Cookies.prototype.getCookie = function (type) {
        return cookie.load(type);
    };
    /**
     *
     * @param type
     * @param value
     */
    Cookies.prototype.setCookie = function (type, value) {
        var expires = new Date();
        expires.setDate(expires.getDate() + COOKIE_EXPIRES);
        cookie.save(type, value, { path: '/', expires: expires, secure: false });
    };
    /**
     *
     * @param type
     */
    Cookies.prototype.removeCookie = function (type) {
        cookie.remove(type);
    };
    return Cookies;
}());
var cookies = new Cookies();
export default cookies;
